import { IUserProfile } from '../types/user'

export const setTokenLocalStorage = (token: string) => {
    window.localStorage.setItem('jp_t', token)
}

export const removeUserDataLocalStorage = () => {
    localStorage.removeItem('jp_t')
    localStorage.removeItem('u')
}

export const setUserLocalStorage = (user: IUserProfile | null) => {
    window.localStorage.setItem('u', JSON.stringify(user))
}

export const getTokenLocalStorage = () => {
    const json = localStorage.getItem('jp_t')

    if (!json) return null

    let token

    if (typeof json == 'string') {
        token = json
    } else {
        token = JSON.parse(json)
    }

    return token ?? null
}
